var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-vita--grid-matching" },
    [
      _vm.matching.score !== null
        ? _c("div", { staticClass: "matching" }, [
            _c(
              "div",
              {
                staticClass:
                  "matching--category matching--category--no-y-padding mb-1"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "matching--category-items matching--category-items-no-item-x-padding matching--category-items-background-transparent"
                  },
                  [
                    _c("MatchingItem", {
                      staticClass: "matching--item-no-top-margin",
                      attrs: {
                        score: _vm.matching.score,
                        "max-score": _vm.matching.maxScore
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        : _vm.matching.match !== null
        ? _c("IconLink", {
            attrs: {
              icon: _vm.matching.match ? "check-circle" : "cross-circle",
              text: _vm.matching.match ? "Match" : "Kein Match",
              color: _vm.matching.match ? "green" : "red",
              "with-arrow": false,
              "less-left-padding": ""
            },
            on: {
              click: function($event) {
                _vm.showUpgradePopUp = true
              }
            }
          })
        : _c("IconLink", {
            attrs: {
              icon: "question-circle",
              text: "Matching",
              color: "yellow",
              "with-arrow": false,
              "less-left-padding": ""
            },
            on: {
              click: function($event) {
                _vm.showUpgradePopUp = true
              }
            }
          }),
      _vm._v(" "),
      _vm.showUpgradePopUp
        ? _c("UpgradePopUp", {
            attrs: {
              "job-profile-id": _vm.jobProfileId,
              "pseudonym-id": _vm.pseudonymId
            },
            on: {
              upgrade: _vm.onUpgrade,
              hidden: function($event) {
                _vm.showUpgradePopUp = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }